<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Cancer Protocols Master Data.</h1>
          <p>Enter Cancer Protocols Details Master Data below to stay updated </p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">

</section>
<div id="w3l-appointment">
<section class="appointment-section section-gap">

<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post" >
            <div class="fields-grid" >
              <div class="styled-input">
                <label>Protocol Code</label>
                <div class="appointment-form-field">
                    <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()"></span>
                    <input type="text" name="ProtoCode" placeholder="Protocol Code" required="" style="width: 30%;" [(ngModel)]="prHdCode" (change)="retriveProtocolHD()">

                </div>
              </div>
              <div class="styled-input">
                <label>Protocol Description</label>
                <div class="appointment-form-field">
                    <span class="fa fa-bookmark" aria-hidden="true"></span>
                    <input type="text" name="ProtoName" placeholder="Protocol Description" required="" [(ngModel)]="prHdName" >
                </div>
              </div>
                <!--****************** Pere-Medication Table ***************************-->
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Pre-Medication   </label>
                <table>
                  <thead>
                      <tr>
                          <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;height: 5%;">Category</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;height: 30%;">Drug</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 8%;">Dos</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 25%;">Duration</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 7%;">Step</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 25%;height: 40%;">Solution</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 70%;">Select</th>
                      </tr>
                  </thead>
                  <tbody>

                    <tr *ngFor="let pro of PreMedicationList; let i = index" style="height: 50%;">
                      <td data-column="Patient ID" style="height: 5%;">{{pro.prDetCatName}}</td>
                      <td data-column="Patient Name"style="height: 30%;">{{pro.prDetItName}}</td>
                      <td data-column="Patient Name"style="height: 10%;">{{pro.prDetQty}}</td>
                      <td data-column="Patient Name"style="height: 25%;">{{pro.prDetDuration}}</td>
                      <td data-column="Patient Name"style="height: 5%;">{{pro.prDetStep}}</td>
                      <td data-column="Patient Name"style="height: 40%;">{{pro.prDetNotes}}</td>
                      <td data-column="Dos" style="height: 50%;">

                      <button name="BDrug" placeholder = "0" style="width: 100%;height: 100%;" required (click)="SelectPreMedication(pro)" >Select</button>

                          </td>
                      </tr>
                  </tbody>
              </table>
              <div>
                    <button name="AddLine" style="width: 33%; height: 50px;background-color: rgb(70, 70, 247);color: aliceblue;font-weight: bolder;font-size: large;" required (click)="AddNewPreNedicationLine()" >Add New Pre-Medication</button>
              </div>

              <br>
              <br>
              <!--****************** Chemotherapy Table ***************************-->
              <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Chemo   </label>
              <table>
                  <thead>
                      <tr>
                          <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;">Category</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;">Drug</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;">Dos</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 25%;">Duration</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 7%;">Step</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 25%;height: 40%;">Solution</th>
                          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;">Select</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cho of ChemoList; let i = index" style="height: 50%;">
                      <td data-column="Patient ID" style="height: 5%;">{{cho.prDetCatName}}</td>
                      <td data-column="Patient Name"style="height: 50%;">{{cho.prDetItName}}</td>
                      <td data-column="Patient Name"style="height: 50%;">{{cho.prDetQty}}</td>
                      <td data-column="Patient Name"style="height: 25%;">{{cho.prDetDuration}}</td>
                      <td data-column="Patient Name"style="height: 5%;">{{cho.prDetStep}}</td>
                      <td data-column="Patient Name"style="height: 40%;">{{cho.prDetNotes}}</td>
                      <td data-column="Dos" style="height: 50%;">
                           <button name="Drug" placeholder = "0" style="width: 100%;height: 100%;" required (click)="SelectPreMedication(cho)">Select</button>
                      </td>
                      </tr>

                  </tbody>
              </table>
              <div class="styled-input">
                <div>
                  <button name="AddLine" style="width: 33%; height: 50px;background-color: rgb(70, 70, 247);color: aliceblue;font-weight: bolder;font-size: large;" required (click)="AddNewChemoLine()" >Add New Chemotherapy</button>
                </div>

              </div>
              <br>
              <br>
                <!--****************** Supportive Druge Table ***************************-->
                          <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Supportive Drugs   </label>
                          <table>
                              <thead>
                                  <tr>
                                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;">Category</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;">Drug</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;">Dos</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 25%;">Duration</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 7%;">Step</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 25%;height: 40%;">Solution</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;">Select</th>
                                  </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let sup of SupprtList; let i = index" style="height: 50%;">
                                  <td data-column="Patient ID" style="height: 5%;">{{sup.prDetCatName}}</td>
                                  <td data-column="Patient Name"style="height: 50%;">{{sup.prDetItName}}</td>
                                  <td data-column="Patient Name"style="height: 50%;">{{sup.prDetQty}}</td>
                                  <td data-column="Patient Name"style="height: 25%;">{{sup.prDetDuration}}</td>
                                  <td data-column="Patient Name"style="height: 5%;">{{sup.prDetStep}}</td>
                                  <td data-column="Patient Name"style="height: 40%;">{{sup.prDetNotes}}</td>
                                  <td data-column="Dos" style="height: 50%;">
                                       <button name="Drug" placeholder = "0" style="width: 100%;height: 100%;" required (click)="SelectPreMedication(sup)">Select</button>
                                  </td>
                                  </tr>

                              </tbody>
                          </table>
                          <div class="styled-input">
                            <div>
                              <button name="AddLine" style="width: 33%; height: 50px;background-color: rgb(70, 70, 247);color: aliceblue;font-weight: bolder;font-size: large;" required (click)="AddNewSupportiveLine()" >Add New Supportive</button>
                            </div>

                          </div>

            <br>
            <br>

                <button type="button" class="theme-button btn" name="submit" style="width: 27%;" (click)="submitProtocolHD()">Submit</button>
                <button type="button" class="theme-button btn" name="Delete" style="width: 27%;" (click)="mesgDelete()">Delete</button>
                <button type="button" class="theme-button btn" name="New" style="width: 27%;" (click)="NewData()">New</button>
                <a href="Home">
                  <button type="button" class="theme-button btn" style="width: 81%;" name="Back">Home</button>
                </a>
                <div class="clear"> </div>
            </div>
        </form>
    </div>


  <div class="fields-grid">
<!--2nd Coloumn-->
    <div class="styled-input">
      <label></label>

      <label>                      </label>
      <div class="appointment-form-field">
      </div>
    </div>

    <div class="styled-input">
    <label>Cycle</label>
    <label>                No. of Days</label>
      <div class="appointment-form-field">
          <span class="fa fa-hotel" aria-hidden="true"></span>
          <input type="text" name="cycle" [(ngModel)]="prHdCycle"  placeholder="00.00" required="" style="width: 25%;">
          <label>   </label>
          <span class="fa fa-calendar-check-o" aria-hidden="true"></span>
          <input type="text" name="days" [(ngModel)]="prHdDays" placeholder="00.00" required="" style="width: 25%;">
          <label>Days</label>
      </div>
    </div>

                    <div class="styled-input">


                    <label>Notes</label>
                    <br>
                    <br>

                    <div class="appointment-form-field">
                        <span class="fa fa-university" aria-hidden="true" style="height: 280%;"></span>
                        <textarea rows = "5" cols = "60" name = "description" [(ngModel)]="prHdNotes"  class="appointment-form-field" maxlength="250ch" style="height: 280%;"> Enter details here... </textarea><br>
                    </div>
                </div>

</div>


----
</div>
<div class="clear"> </div>
</div>
</section>
</div>
